import React, { createContext, useReducer } from 'react'

const initialState = {
  password: null,
  email: null,
  code: null,
  firstName: null,
  lastName: null,
}

const emptyFn = () => undefined

export const reducer = (state, action) => {
  switch (action.type) {
    case 'signInFormSubmitted': {
      const { payload } = action
      const { email, password } = payload

      return {
        ...state,
        email,
        password,
      }
    }

    case 'signUpFormSubmitted': {
      const { payload } = action
      const { email, password, firstName, lastName } = payload

      return {
        ...state,
        email,
        password,
        firstName,
        lastName,
      }
    }

    case 'signUpCompleted': {
      return {
        ...initialState,
      }
    }

    case 'signIntoSignUp': {
      return {
        email: action.payload,
      }
    }

    case 'signIntoSignUpMob': {
      const { payload } = action
      const { email, password, firstName, lastName } = payload

      return {
        ...state,
        email,
        password,
        firstName,
        lastName,
      }
    }

    case 'signUpMobSubmitted': {
      const { payload } = action
      const { email, password, firstName, lastName } = payload
      return {
        ...state,
        email,
        password,
        firstName,
        lastName,
      }
    }

    case 'forgotPasswordFormSubmitted': {
      return {
        ...state,
        email: action.payload,
      }
    }

    case 'createNewPasswordFormSubmitted': {
      const { payload } = action
      const { email, password, code } = payload

      return {
        ...state,
        email,
        password,
        code,
      }
    }

    default:
      return state
  }
}

export const AuthStateContext = createContext([initialState, emptyFn])

export const AuthStateProvider = ({ children }) => {
  const contextValue = useReducer(reducer, initialState)

  return <AuthStateContext.Provider value={contextValue}>{children}</AuthStateContext.Provider>
}
